import AeonikRegularWoff2 from './Aeonik-Regular.woff2';
import AeonikBoldWoff2 from './Aeonik-Bold.woff2';
import AeonikMediumWoff2 from './Aeonik-Medium.woff2';
import AeonikRegularWoff from './Aeonik-Regular.woff';
import AeonikBoldWoff from './Aeonik-Bold.woff';
import AeonikMediumWoff from './Aeonik-Medium.woff';

function addFonts() {
  const style = document.createElement('style');
  style.appendChild(
    document.createTextNode(`
  @font-face {
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: local('Aeonik'), local('Aeonik-Regular'), 
         url(${AeonikRegularWoff2}) format('woff2'), url(${AeonikRegularWoff}) format('woff');
  }
  @font-face {
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: local('Aeonik'), local('Aeonik-Medium'), 
         url(${AeonikMediumWoff2}) format('woff2'), url(${AeonikMediumWoff}) format('woff');
  }
  @font-face {
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: local('Aeonik'), local('Aeonik-Bold'), 
         url(${AeonikBoldWoff2}) format('woff2'), url(${AeonikBoldWoff}) format('woff');
  }
  `)
  );
  document.head.appendChild(style);
}

addFonts();
